<template>
  <div class="main">
    <div class="container">
      <img src="../../assets/down_text_top.png" style="object-fit: contain; width: 330px; margin-top: 30px;" alt=""/>
      <img src="../../assets/down_text_yyjj.png" class="playlet_logo" style="margin-top: 50px;" />
      <div v-if="isRegister" class="playlet_success_tip" style="display: block">
        恭喜你，注册成功
      </div>
      <div
        v-if="ios"
        @click="openMini"
        class="playlet_success_btn"
        id="iosDownLoadUrl"
        target="_blank"
      >
        <img
          src="http://img3.hzhstb.com/8ae13575837862324cb2b6dd45616f60_32x26.png"
          class="playlet_success_btn_icon iphone"
        />
        打开微信小程序
      </div>
      <div
        v-if="false"
        class="playlet_success_tips"
        id="iosCertifyUrl"
        target="_blank"
      >
        苹果iOS需要信任证书 解决方法 &gt;
      </div>

      <div class="breath">
        <img
        v-if="!ios" 
         @click="andoridDownLoadUrl"
          src="../../assets/down_btn.png"
          style="width:250px; object-fit: contain; margin-top: 15px;"
        />
      </div>
    

        <img src="../../assets/down_text_rigist.png" alt="" style="width: 250px; align-self: flex-start; margin-left: 10px; margin-top: 50px;"/>
      <div style="margin-top: 40px; width: 100%; height: 120px; background-color: #431B23; position: relative; ">
        <img src="../../assets/down_pic_1.png" alt="" style="width:360px;position: absolute;right: 0;top: 0;bottom: 0;margin: auto; "/>
      </div>
      
      <div style="position: relative; width: 100%;">
       
        <img src="../../assets/down_btm_pic.png" alt="" style="position: absolute; object-fit: cover; width: 100%; left: 0;right: 0;"/>
        <img src="../../assets/down_text_btm.png" alt="" style="position: absolute; width: 90%; object-fit: cover; right: 0; top: 20px;"/>
      </div>
    </div>
    
    <div v-if="showWxBrower" class="tip">
      <img src="../../assets/wx_tip2.png" alt="" class="tip2" />
      <div class="tip3">
        <div>1.请点击右上角</div>
        <div>2.选择【在默认浏览器打开】</div>
      </div>
      <img src="../../assets/wx_tip1.png" alt="" class="tip4"/>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isRegister: false,
      downLoadUrl: "",
      showWxBrower: false,
      ios: false,
      miniScheme:''
    };
  },
  mounted() {
    this.isRegister = this.$route.query.isRegister;
    this.getVersion();
    // this.appSource();
    // this.getScheme();
  },
  methods: {
    getVersion() {
      this.$request.GET({
        url: "app/version",
        params: { version: "1.0.0" },
        success: (res) => {
          this.downLoadUrl = res.downloadUrl;
        },
      });
    },
    andoridDownLoadUrl() {
      if (this.isWeiXin()) {
        this.showWxBrower = true;
      } else {
        location.href = this.downLoadUrl;
      }
    },
    isWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase();
      // ua.indexOf('micromessenger')为真-微信端，如果为假，就是其他浏览器
      if (ua.indexOf("micromessenger") > -1) {
        return true; // 是微信端
      } else {
        return false;
      }
      // return true;
    },
    openMini(){
      window.location.href= this.miniScheme;
    },
    getScheme(){
      this.$request.GET({
        url:'homepage/mini',
        success:(obj)=>{
          this.miniScheme = obj.url
        }
      })
    },
    appSource() {
      const u = navigator.userAgent,
        app = navigator.appVersion;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isiOS) {
        this.ios = true;
      } else {
        this.ios = false;
      }
    },
  },
};
</script>

<style scoped>
.main{
  width: 100%;
  position: relative;
}
.container {
  width: 100%;
  background-image: url(../../assets/down_bg.png);
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  font-size: 0.32rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
}

.column {
  display: flex;
  flex-direction: column;
}
.row {
  display: flex;
  flex-direction: row;
}

.btm{
  background:url(../../assets/down_btm_pic.png); 
  background-repeat: no-repeat;
  background-size: 100%;
  width:100%; 
  object-fit: contain;
}

.tip {
  position: absolute;
  width: 100%;
  top:0;
  bottom: 0;
  overflow-y: hidden;
  background: black;
  opacity: 0.9;
}

.tip2 {
  position: absolute;
  right: 0;
}
.tip3 {
  position: absolute;
  left: 16px;
  top: 30px;
  font-size: 18px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 28px;
  text-align: left;
}

.tip4{
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  margin: auto;
}

a {
  text-decoration: none;
  color: #141414;
}

input {
  background: none;
  outline: none;
  border: none;
}

input:focus {
  border: none;
}

.playlet_logo {
  width: 160px;
  object-fit: contain;
  
}

.playlet_success_tip {
  font-size: 18px;
  font-weight: bold;
  color: #A8A8A8;
  margin-top: 10px;
  display: none;
}

.playlet_success_blank {
  width: 100%;
  height: 4rem;
}

.playlet_success_btn {
  width: 6.54rem;
  height: 0.88rem;
  background-color: #141414;
  border-radius: 0.04rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.playlet_success_btn_icon {
  margin-right: 0.16rem;
}

.playlet_success_btn_icon.iphone {
  width: 0.26rem;
  height: 0.32rem;
}

.playlet_success_btn_icon.android {
  width: 0.4rem;
  height: 0.22rem;
}

.playlet_success_tips {
  margin: 0.16rem 0 0.48rem;
}

.playlet_extra_wrap {
  display: none;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.85);
}

.playlet_extra {
  width: 100%;
  height: 100%;
  background-position: top;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url(http://img2.hzhstb.com/d42e645d9d65025ccee323d3032dfce4_1926x1125.png);
}

/* 定义呼吸动画的关键帧 */
@keyframes breathing {
  0%, 100% { transform: scale(1); } /* 元素在动画开始和结束时恢复原大小 */
  50% { transform: scale(1.1); } /* 在动画中间点放大10% */
}

/* 应用呼吸动画到一个元素上 */
.breath{
  animation-name: breathing; /* 引用定义好的关键帧动画 */
  animation-duration: 1s; /* 动画持续时间 */
  animation-iteration-count: infinite; /* 动画无限循环 */
  animation-timing-function: ease-in-out; /* 动画速度曲线 */
}

</style>